<!-- 页面内容 -->

<template>
    <!-- container -->
    <div class='content'>
        <div class="container cont">
            <div class="contV">
                <div class="topA">
                    <div class="topA1">
                        <div class="t1">PRODUCT DESCRIPTION</div>
                        <div class="line"></div>
                    </div>
                    <div class="topA2" style="cursor: pointer;" @click="goForm">Customize</div>
                </div>
                <div ref="richTextContainer" class="vhtml-style" style="margin-top: 20px;" v-html="Text"></div>
                <!-- <div class="imgV">
                    <img class="t3" src="@/assets/images2/16.png" alt="" />
                    <img class="t1" src="@/assets/images2/15.png" alt="" />
                    <div class="t2"></div>
                </div>
                <div class="wz">Our customization process </div>
                <div class="ts">
                    <div class="tsV">
                        <div class="n1">
                            <img class="n11" src="@/assets/images2/17.png" alt="" />
                            <div class="n12">Step 1</div>
                            <div class="n13">Fill in the customized form</div>
                        </div>
                        <img class="go" src="@/assets/images2/23.png" alt="" />
                        <div class="n1">
                            <img class="n11" src="@/assets/images2/18.png" alt="" />
                            <div class="n12">Step 2</div>
                            <div class="n13">Customer service contact</div>
                        </div>
                        <img class="go" src="@/assets/images2/23.png" alt="" />
                        <div class="n1">
                            <img class="n11" src="@/assets/images2/19.png" alt="" />
                            <div class="n12">Step 3</div>
                            <div class="n13">Sign a contract</div>
                        </div>
                        <img class="go" src="@/assets/images2/23.png" alt="" />
                        <div class="n1">
                            <img class="n11" src="@/assets/images2/20.png" alt="" />
                            <div class="n12">Step 4</div>
                            <div class="n13">Sample/Mass production</div>
                        </div>
                        <img class="go" src="@/assets/images2/23.png" alt="" />
                        <div class="n1">
                            <img class="n11" src="@/assets/images2/21.png" alt="" />
                            <div class="n12">Step 5</div>
                            <div class="n13">Delivery</div>
                        </div>
                        <img class="go" src="@/assets/images2/23.png" alt="" />
                        <div class="n1">
                            <img class="n11" src="@/assets/images2/22.png" alt="" />
                            <div class="n12">Step 6</div>
                            <div class="n13">After-sales tracking</div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            Text: ''
        }
    },
    mounted() {
        this.getCustomizedApi();
        this.makeImagesResponsive();
    },
    methods: {
        makeImagesResponsive() {
            const container = this.$refs.richTextContainer;
            const images = container.getElementsByTagName('img');

            for (let i = 0; i < images.length; i++) {
                const img = images[i];
                img.style.width = '1300px'; // 设置图片最大宽度为100%  
                img.style.height = 'auto'; // 保持图片原始纵横比  
            }

            const qlideo = container.getElementsByTagName('ql-video');

            for (let i = 0; i < qlideo.length; i++) {
                const qlideos = qlideo[i];
                qlideos.style.width = '100%'; // 设置图片最大宽度为100%  
                qlideos.style.height = 'auto'; // 保持图片原始纵横比  
            }



            const videos = container.getElementsByTagName('video');

            for (let i = 0; i < videos.length; i++) {
                const video = videos[i];
                video.style.width = '100%'; // 设置图片最大宽度为100%  
                video.style.height = 'auto'; // 保持图片原始纵横比  
            }

            const iframes = container.getElementsByTagName('iframe');

            for (let i = 0; i < iframes.length; i++) {
                const iframe = iframes[i];
                iframe.style.width = '100%'; // 设置图片最大宽度为100%  
                iframe.style.height = '472px'; // 保持图片原始纵横比  
            }
        },
        // 定制图文
        async getCustomizedApi() {
            try {
                const res = await this.$get('system/content/getCustomized');
                this.Text = res.data.content
                console.warn(res, "定制图文")
            } catch (error) {
            }
        },
        goForm() {
            console.warn('+++++++++')
            this.$router.push({
                path: "customizationFrom"
            })
        }
    },
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>